<template>
    <div>
        <b-modal
            id="select_store_modal"
            modal-class=""
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <p id="headline" v-html="headline"></p>
                    <p id="headline2" v-html="headline2"></p>
                </div>
                <div class="province mb-4" :class="{'disable-dropdown': provinceList.length <= 0}">
                    <b-dropdown class="ddl-default"
                            variant="ddl-default"
                            menu-class="ddl-menu"
                            :text="texProvince"
                            :disabled="disableMonth">
                        <b-dropdown-item v-for="(v,k) in provinceList" :key="k" @click="selectProvince(v)">
                            {{localeCode.getLocaleCode() === 1054 ? v.ProvinceName: v.ProvinceName_EN }}
                        </b-dropdown-item>
                    </b-dropdown>
                </div>

                <div class="brance mb-4" :class="{'disable-dropdown': branceList.length <= 0}">
                    <b-dropdown class="ddl-default"
                            variant="ddl-default"
                            menu-class="ddl-menu"
                            :text="texBrance"
                            :disabled="disableMonth">
                        <b-dropdown-item v-for="(v,k) in branceList" :key="k" @click="selectBrance(v)">
                            {{localeCode.getLocaleCode() === 1054 ? v.Name: v.NameEN }}
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
                <div class="modal-base-footer btn-redeem-wrapper">
                    <button class="btn btn-cancel" @click="clickCloseSelectStore()">{{lblConfirmRedeem.cancel}}</button>
                    <button class="btn ml-2 btn-confirm" @click="clickConfirmSelectStore()">{{lblConfirmRedeem.confirm}}</button>
                </div>
            </div>
        </b-modal>
        <modal view="select-store"
            :busModal="busModal"
            @modalAlertHidden="clickOkModalAlert($event)"></modal>
    </div>
</template>
<script>
//import Vue from "vue";
import Util from "@/helper/Utility.js";
import Moment from "moment";
import Locale from "@/helper/locale/locale.js";
import Account from '@/helper/AccountHelper.js';
import BzbsAddress from '@/service/BzbsAddress.js';


import Modal from '@/components/modal/Modal.vue';

export default {
    name: 'SelectStoreModal',
     components: {

        Modal,
    },
    props: {
        lbl: Object,
        campaign: Object,
        busModal: Object
    },
    data: function () {
        return {
            headline: '',
            headline2: '',
            message: '',
            texProvince: '',
            texDistrict: '',
            texBrance: '',
            texProvinceInfo3: '',
            texDistrictInfo3: '',
            texBranceInfo3: '',
            disableMonth: false,

            lblConfirmRedeem: {},
            lblDate: {},
            monthList:[],
            provinceList:[],
            districList: [],
            branceList: [],

            objInfo:{
                proviceName: '',
                proviceCode: '',
                branchName: '',
                branchCode: '',
            },

            localeCode: Locale,
            // busModal: new Vue(),
        };
    },
    mounted: function () {
        console.log("confirmredeem");
        this.lblDate = this.lbl.date;
        this.lblConfirmRedeem = this.lbl.gift_detail;
        this.busModal.$on('showSelectStoreModal', this.initialConfirmModal);
        this.busModal.$on('hideSelectStoreModal', this.closeConfirmModal);
        this.getProviceStore();

    },
    methods: {
        //Event
        clickConfirmSelectStore: function () {

            if (this.texProvince == this.lblConfirmRedeem.province) {
                  this.showAlertModal(this.lblConfirmRedeem.reward_confirm,
                                    this.lblConfirmRedeem.pleasefill,
                                    this.lbl.shipping.alert_ok_btn,
                                    "stroe");
                return;
            }
            if (this.texBrance == this.lblConfirmRedeem.brance) {
                 this.showAlertModal(this.lblConfirmRedeem.reward_confirm,
                                    this.lblConfirmRedeem.pleasefill,
                                    this.lbl.shipping.alert_ok_btn,
                                    "stroe");
                return;
            }
            // console.log(this.info3 = "Store brance");
            this.$emit('clickConfirmSelectStore', this.objInfo);
            this.districList = [];
            this.branceList = [];
            this.closeConfirmModal();
        },
        clickCloseSelectStore: function () {
            this.districList = [];
            this.branceList = [];
            this.closeConfirmModal();
        },
        //Function
        initialConfirmModal: function () {

            this.headline = this.lblConfirmRedeem.header;
            this.headline2 = this.lblConfirmRedeem.header2;

            this.texProvince = this.lblConfirmRedeem.province;

            this.texBrance = this.lblConfirmRedeem.brance;
            this.message = this.lblConfirmRedeem.default1 + " " + this.campaign.pointPerUnit + " " + this.lblConfirmRedeem.default2;

            this.$bvModal.show('select_store_modal');

        },
        closeConfirmModal: function () {
            this.$bvModal.hide('select_store_modal');
        },
        //Utilities
        getTimerMessage: function (message, minutes) {
            var result = '';
            var days = '';
            var hours = '';
            var minuteAfterUsed = minutes;
            if (minuteAfterUsed >= 60) {
                hours = Math.floor(minuteAfterUsed / 60);
                if (hours >= 24) days = Math.floor(hours / 24);
            }

            if (days) result += days + ' ' + this.lblDate.days + ' ';
            if (hours) result += hours + ' ' + this.lblDate.hours + ' ';
            if (minutes / 60 > 0) result += (minutes % 60) + ' ' + this.lblDate.minutes_short;

            return Util.stringFormat(message, result);
        },
        getDrawMessage: function (message) {
            var expireDate = this.campaign.expireDate;
            var result = Moment.unix(expireDate).utc();
            var year = Moment.unix(expireDate).utc().format('YYYY');
            if (Locale.getLocaleCode() === 1054) year = result.get('year') + 543;

            var monthString = this.lblDate.month_short[result.format('M') - 1];
            var strDate = result.format('DD') + " " + monthString + " " + year
                        + ' | ' + result.format('HH:mm');

            return Util.stringFormat(message, strDate);
        },
        getProviceStore: function () {

            var bzbsToken = Account.getToken();

                BzbsAddress.apiGetProvinceStore(bzbsToken).then((data) => {
                    //Reset array.
                    this.provinceList = data.data;
                   console.log(data);
                }).catch((error) => {
                    console.log(error);
                });
        },
        selectProvince: function(value) {
            console.log(value);

            this.texProvince = Locale.getLocaleCode() === 1054 ? value.ProvinceName : value.ProvinceName_EN;

            this.objInfo.proviceName = this.texProvince;
            this.objInfo.proviceCode = value.ProvinceCode;

            this.getBranceStore(value.ProvinceCode);

        },
        getBranceStore: function (districtCode) {

            var bzbsToken = Account.getToken();

                BzbsAddress.apiGetBranceByProvince(bzbsToken, districtCode).then((data) => {
                    //Reset array.
                    this.branceList = data.data;

                    //  this.texBrance = Locale.getLocaleCode() === 1054 ? this.branceList[0].Name : this.branceList[0].NameEN;
                    // this.texBrance = this.branceList[0].Name;
                   console.log(data);
                }).catch((error) => {
                    console.log(error);
                });
        },
        selectBrance: function(value) {

            this.texBrance = Locale.getLocaleCode() === 1054 ? value.Name : value.NameEN;
            this.texBranceInfo3 = value.NameEN;

            this.objInfo.branchName = this.texBrance;
            this.objInfo.branchCode = value.ReferenceCode;
            // this.texBrance = value.Name;

        },
        showAlertModal: function(title, message, btnOk, tag) {
            var configModal = {
                title: title,
                message: message,
                strBtnOk: btnOk,
                tag: tag,
            };
            this.busModal.$emit('showAlertModal', configModal);
        },
        clickOkModalAlert: function (e) {
           console.log(e);

        },

    }
}
</script>
<style lang="scss">
    $url-dropdown-icon: url('../../../../assets/img/01-register/dropdown@3x.png');
    @import "@/style/base/common.scss";
    @import "@/style/base/inputCustom/Dropdown.scss";

    #select_store_modal{

        .modal-dialog{
            margin-left: 2rem;
            margin-right: 2rem;
            .modal-content{

                border-radius: 0px;
            }
        }
    }
</style>
<style lang="scss" scoped>
    #headline {
        text-align: center;
        font-weight: bold;
    }
    #headline2 {
        text-align: center;
    }

    #message {
        text-align: center;
    }

    #select_store_modal{

        .btn-redeem-wrapper {
            text-align: center;
            display: flex;
            flex-wrap: nowrap;

            .btn-cancel {
                width: 50%;
                background-color: white;
                color: black;
                border-color: black;
                border-radius: 0;
            }

            .btn-confirm {
                width: 50%;
                background-color: black;
                color: white;
                border-color: black;
                border-radius: 0;
            }
        }

        .disable-dropdown {
            pointer-events: none;
        }
    }
</style>
